module.exports = __webpack_public_path__ + "media/images/favicon_master-1922a607a6e8cff46696c90ff35a6587.png";